import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemValidationButtonSettingsForm = _resolveComponent("SystemValidationButtonSettingsForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_component_BlockUI, { blocked: _ctx.loading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value.settings, (setting, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-d-flex p-ai-start p-mb-3 p-col-12"
          }, [
            _createVNode(_component_SystemValidationButtonSettingsForm, {
              setting: setting,
              onLoad: _cache[0] || (_cache[0] = (l) => _ctx.loading = l)
            }, null, 8, ["setting"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["blocked"]))
}